import { render, staticRenderFns } from "./oferta-form.vue?vue&type=template&id=82ad8f1a&scoped=true"
import script from "./oferta-form.vue?vue&type=script&lang=js"
export * from "./oferta-form.vue?vue&type=script&lang=js"
import style0 from "./oferta-form.vue?vue&type=style&index=0&id=82ad8f1a&prod&lang=css"
import style1 from "./oferta-form.vue?vue&type=style&index=1&id=82ad8f1a&prod&scoped=true&lang=css"
import style2 from "./oferta-form.vue?vue&type=style&index=2&id=82ad8f1a&prod&scoped=true&lang=css"
import style3 from "./oferta-form.vue?vue&type=style&index=3&id=82ad8f1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82ad8f1a",
  null
  
)

export default component.exports